import { CsTournamentTimeline } from "./components/CsTournamentTimeline";
import { CombinedTournamentTimeline } from "./components/CombinedTournamentTimeline";
import { DotaTournamentTimeline } from "./components/DotaTournamentTimeline";
import { RlTournamentTimeline } from "./components/RlTournamentTimeline";
import { GameIdContext } from "@portal-frontend-ssr/providers";
import { useContext } from "react";
import { TournamentTimeline as TournamentTimelineType } from "@portal-frontend-ssr/blast-data-api";

export const TournamentTimeline = ({ data }: { data: TournamentTimelineType }) => {
  const { gameId } = useContext(GameIdContext);

  if (gameId === "cs") {
    return <CsTournamentTimeline data={data} />;
  }
  if (gameId === "dota") {
    return <DotaTournamentTimeline data={data} />;
  }
  if (gameId === "rl") {
    return <RlTournamentTimeline data={data} />;
  }
  if (gameId === null) {
    return <CombinedTournamentTimeline data={data} />;
  }
};
